import ServiceCRUD from '../../../../services/ServiceCRUDFLEXUC';

class CostCenterService extends ServiceCRUD {
  constructor() {
    super(`/api/centrosdecusto`);
  }
}

export default new CostCenterService();
